var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-sm btn--primary px-4 ml-3",attrs:{"type":"button"},on:{"click":_vm.openSubscribeModal}},[_vm._v(" Subscribe ")]),_c('CreateSubscriptionModal',{attrs:{"id":'subscribe',"closeModal":_vm.closeModal,"subRef":_vm.subRef,"refetch":_vm.refetch,"plan":_vm.plan}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }